import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cn } from "../libs/utils";
import { usePortalContainer } from "../../hooks/PortalContainerProvider";
const TooltipProvider = TooltipPrimitive.Provider;
const Tooltip = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;
const TooltipContent = React.forwardRef(({ className, sideOffset = 4, side = "top", ...props }, ref) => {
    const container = usePortalContainer();
    return (_jsx(TooltipPrimitive.Portal, { container: container, children: _jsx(TooltipPrimitive.Content, { ref: ref, sideOffset: sideOffset, side: side, style: { zIndex: 100 }, className: cn("max-w-[90vw]", "z-50 overflow-hidden rounded-md bg-tooltips border border-border px-3 py-1.5 text-xs animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className), ...props }) }));
});
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
export function VTooltip({ description, children, size = 'sm', placement = 'top', className, asChild }) {
    const [open, setOpen] = React.useState(false);
    const suppressRef = React.useRef(false);
    React.useEffect(() => {
        const suppress = () => {
            setOpen(false);
            suppressRef.current = true;
            requestAnimationFrame(() => { suppressRef.current = false; });
        };
        window.addEventListener('blur', suppress);
        document.addEventListener('visibilitychange', suppress);
        return () => {
            window.removeEventListener('blur', suppress);
            document.removeEventListener('visibilitychange', suppress);
        };
    }, []);
    return (_jsx(TooltipProvider, { delayDuration: 0, children: _jsxs(Tooltip, { open: open, onOpenChange: (v) => { if (!suppressRef.current)
                setOpen(v); }, children: [_jsx(TooltipTrigger, { className: "cursor-pointer", asChild: asChild, children: children }), _jsx(TooltipContent, { side: placement, className: `px-3 py-1.5 max-w-${size} text-${size} px-3 ${className}`, children: description })] }) }));
}
export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
//# sourceMappingURL=tooltip.js.map